// @flow
import React from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'
import theme from 'styled-theming'
import hexToRgba from 'hex-to-rgba'

import Arrow from '../arrow'
import { myTheme } from '../../../styles'

const {
  space, color, borderRadii, breakpoint,
} = myTheme

const titleThemeColor = theme('mode', {
  dark: color.white,
  light: color.darkBlueGray,
})
const ListItem = styled.li``
const PostDetails = styled.div``
const PostTitle = styled.h4`
  margin: 0;
  margin-bottom: ${space.one};
  line-height: 1.4;
  font-size: 18px;
  font-weight: 400;
  letter-spacing: -0.45px;
  color: ${titleThemeColor};
`
const dateThemeColor = theme('mode', {
  dark: color.darkSilver,
  light: color.silver,
})
const PostDate = styled.p`
  margin: 0;
  color: ${dateThemeColor};
  font-size: 0.875rem;
  letter-spacing: -0.15px;
`
const hoverStateBackground = theme('mode', {
  dark: hexToRgba(color.white, 0.03),
  light: hexToRgba(color.black, 0.03),
})
const StyledLink = styled(Link)`
  text-decoration: none;
  color: ${color.offWhite};
  padding: ${space.one} 0;

  @media screen and (min-width: ${breakpoint.small}) {
    background: transparent;
    transition: background 100ms ease-in-out;
    border-radius: ${borderRadii.two};
    padding-left: ${space.one};
    padding-right: ${space.one};
    margin-left: -${space.one};
    margin-right: -${space.one};
    margin-bottom: ${space.half};

    &:hover {
      background: ${hoverStateBackground};
    }
  }
`
const ArrowContainer = styled.div`
  margin-right: -${space.two};
`

type Props = {
  title: string,
  date: string,
  to: string,
}

const PostItem = ({ title, date, to }: Props) => (
  <ListItem>
    <StyledLink
      to={to}
      className="flex items-center"
    >
      <PostDetails>
        <PostTitle>{title}</PostTitle>
        <PostDate>{date}</PostDate>
      </PostDetails>
      <ArrowContainer className="ml-auto">
        <Arrow />
      </ArrowContainer>
    </StyledLink>
  </ListItem>
)

export default PostItem



// WEBPACK FOOTER //
// ./src/scenes/feed/post-link/post-link.js